module.exports = __webpack_public_path__ + "img/one.7b29c9ec.webp";